import React from 'react';
import PropTypes from 'prop-types';
import withConfig from 'config/withConfig';
import IconCenter from '@spothero/icons/center';
import IconPlus from '@spothero/icons/plus';
import IconMinus from '@spothero/icons/minus';
import IconLocationArrow from '@spothero/icons/location-arrow';
import Button from '@spothero/ui/button';

const SpotMapControls = ({
    isMobile,
    isDestinationOutOfBounds,
    zoom,
    onZoomIn,
    onZoomOut,
    onGoToCurrentLocation,
    onReturnToDestination,
}) => {
    return (
        <div className="SpotMapControls">
            {!isMobile && (
                <div className="SpotMapControl-zoom">
                    <Button
                        className="SpotMapControl SpotMapControl-zoom-in"
                        onClick={onZoomIn}
                        disabled={zoom > 19}
                    >
                        <IconPlus />
                    </Button>
                    <Button
                        className="SpotMapControl SpotMapControl-zoom-out"
                        onClick={onZoomOut}
                        disabled={zoom < 4}
                    >
                        <IconMinus />
                    </Button>
                </div>
            )}
            {isMobile && onGoToCurrentLocation && (
                <Button
                    className="SpotMapControl SpotMapControl-go-to-current-location"
                    onClick={onGoToCurrentLocation}
                >
                    <IconLocationArrow />
                </Button>
            )}
            {!isMobile && isDestinationOutOfBounds && (
                <Button
                    className="SpotMapControl SpotMapControl-return-to-destination"
                    onClick={onReturnToDestination}
                >
                    <IconCenter />
                </Button>
            )}
        </div>
    );
};

SpotMapControls.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isDestinationOutOfBounds: PropTypes.bool.isRequired,
    zoom: PropTypes.number.isRequired,
    onZoomIn: PropTypes.func.isRequired,
    onZoomOut: PropTypes.func.isRequired,
    onGoToCurrentLocation: PropTypes.func,
    onReturnToDestination: PropTypes.func.isRequired,
};

export default withConfig(['isMobile'])(SpotMapControls);
